exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-error[data-v-a2a8b680] {\n  background-color: #ffe6e6 !important;\n}\n.form-error[data-v-a2a8b680] {\n  position: relative;\n}\n.form-error span[data-v-a2a8b680]{\n  position: absolute;\n  left: 0;\n  bottom: -23px;\n  color: red;\n  font-size: 0.8rem;\n}\n.non-border-top[data-v-a2a8b680] {\n  border-top: 0 !important;\n}\n", ""]);

// exports
